import { Box } from "@mui/material";
import AdminSideNavLayout from "./components/AdminSideNavLayout/AdminSideNavLayout";
import BlogAnalyticsSection from "./components/BlogAnalyticsSection/BlogAnalyticsSection";
import adminDashboardStyles from "./AdminDashboard.styles";

const AdminAnalyticsPage = () => {
  const styles = adminDashboardStyles;
  return (
    <AdminSideNavLayout>
      <Box sx={styles.root}>
        <Box sx={styles.section}>
          <BlogAnalyticsSection />
        </Box>
      </Box>
    </AdminSideNavLayout>
  );
};

export default AdminAnalyticsPage;
